import { api } from "@/api";

import { PaginatedResponse, QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";


// Sport category as used by the sport-events API. Widened for basketball;
// existing football call sites keep passing "football".
export type SportType = "football" | "basketball";


export interface GetSportEventsNewParams {
  feedType: FeedType;
  sportType: SportType;
  lang: string;
  page?: number;
  pageSize?: number;
  minOffset?: string | number;
  leagueIds?: number[];
  popularLeaguesOnly?: boolean;
  excludeMarkets?: boolean;
  // Ask for each event's cached "N odds" badge count. Opt-in: only the Zero
  // prematch board shows the badge, so every other list skips the lookup.
  withOddsCount?: boolean;
}

export const getSportEventsNew = async (
  props: QueryProps<GetSportEventsNewParams>
): Promise<SportEvent[]> => {
  const res = await api.client.get("/sport-events-new", {
    signal: props.signal,
    params: props.params,
  });
  return res.data.items;
};

// Lightweight variant: returns only the total match count from the paginated
// `meta`, so per-sport tab badges can show counts without loading the full
// event lists (callers pass pageSize=1 & excludeMarkets to keep it cheap).
export const getSportEventsCount = async (
  props: QueryProps<GetSportEventsNewParams>
): Promise<number> => {
  const res = await api.client.get("/sport-events-new", {
    signal: props.signal,
    params: props.params,
  });
  return res.data?.meta?.totalItems ?? 0;
};
